import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { LoginForm, type LoginFormValues } from "./components/LoginForm";
import { postRodauth, rodauthSuccess } from "@/lib/rodauth";
import { useCurrentUser } from "@/hooks/useCurrentUser";

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { refetch } = useCurrentUser();

  const handleSubmit = async (values: LoginFormValues) => {
    setLoading(true);
    setError(null);

    try {
      const response = await postRodauth("/login", {
        email: values.email,
        password: values.password,
      });

      const result = await refetch();
      if (result.data?.currentUser) {
        navigate("/dashboard", { replace: true });
        return;
      }

      if (!rodauthSuccess(response)) {
        setError("E-mail ou senha inválidos");
      } else {
        setError("E-mail ou senha inválidos");
      }
    } catch {
      setError("Erro ao entrar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-primary-50 dark:bg-primary-950 flex items-center justify-center px-4">
      <Card className="max-w-md w-full p-6 sm:p-12">
        <CardContent className="p-0">
          <h1 className="text-3xl font-light tracking-tight text-primary-950 dark:text-white mb-8">
            ENTRAR
          </h1>
          <LoginForm onSubmit={handleSubmit} loading={loading} error={error} />
        </CardContent>
      </Card>
    </div>
  );
}
